import G2Logo from '@/shared/assets/icons/g2-logo.svg';
import { Label, Container } from './styled';

export const Title = () => {
  return (
    <Container>
      <img src={G2Logo} alt="G2" width="61" height="57" />

      <Label>Leave a review about Rask and get 25 free minutes!</Label>
    </Container>
  );
};
